import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom";
import { DualAxes } from "@ant-design/plots";
import { Box, makeStyles } from "@material-ui/core";
import IconArrowUp from "assets/img/ic-arrow-up.png";
import IconArrowDown from "assets/img/ic-arrow-down.png";

const ChartStatisticFarm = ({ listStatisticFarm }) => {
  const useStyles = makeStyles({
    container: {
      background: "#FFF",
      boxShadow: "0px 0px 4px 0px #8A8A8A4D",
      padding: "16px",
      "& > h1": {
        color: "#08090D",
        fontSize: 22,
        fontWeight: 600,
        marginBottom: 20,
      },
    },
  });
  const classes = useStyles();
  const mapDataColumn = (listData) => {
    const mappedData = [];

    listData.forEach((data) => {
      const monthName = `Tháng ${data.month}`;
      data.statisticFarms.forEach((item) => {
        mappedData.push({
          month: monthName,
          count: Number(item.farmCount),
          name: item.name,
          type: "total",
          total: Number(data.totalAllFarm).toFixed(),
          pigCount: Number(item.pigCount),
        });
      });
    });

    return mappedData;
  };
  const mapDataLine = (listData) => {
    const mappedData = [];

    listData.forEach((data) => {
      const monthName = `Tháng ${data.month}`;
      data.statisticFarms.forEach((item) => {
        mappedData.push({
          month: monthName,
          avgMark: Number(Number(item.farmAvgMark).toFixed()),
          name: item.name,
          type: "averageMark",
          total: Number(data.markAllFarm).toFixed(),
        });
      });
    });

    return mappedData;
  };

  const columnData = mapDataColumn(listStatisticFarm);
  const lineData = mapDataLine(listStatisticFarm);

  const calcPercentWithPrevMonth = (data) => {
    if (data.month === "Tháng 1") return "";
    const findDataPrevMonth = lineData.find((x) => {
      return (
        Number(data.month.replace("Tháng ", "")) -
          Number(x.month.replace("Tháng ", "")) ===
          1 && x.name === data.name
      );
    });
    const percentPrev =
      Number(findDataPrevMonth.avgMark) - Number(data.avgMark);

    return `<div style="display: flex; align-items: center"><p>${
      percentPrev < 0
        ? '<span style="display: inline-block; font-size: 20px; color: #00ff33">↑</span> Tăng'
        : '<span style="display: inline-block; font-size: 20px; color: #fa0000">↓</span> Giảm'
    }<span > ${Math.abs(percentPrev)}% so với tháng trước </span></p></div>`;
  };

  const config = {
    data: [columnData, lineData],
    height: 600,
    xField: "month",
    yField: ["count", "avgMark"],
    yAxis: [
      {
        min: 0,
        tickInterval: 10,
      },
      {
        min: 0,
        tickInterval: 10,
      },
    ],
    legend: {
      position: "bottom",
      offsetY: 20,
      itemName: {
        formatter: (text, item, index) => {
          return `${item.name} - ${
            index > 1 ? "Điểm trung bình" : "Số lượng trại"
          }`;
        },
      },
    },
    tooltip: {
      shared: false,
      showMarkers: true,

      customContent: (title, items) => {
        return `<div style="padding: 10px;">
                  <h4>${title}</h4>
                  ${items
                    .map((item) =>
                      item.data.type === "averageMark"
                        ? `<div><p style="margin-top: 15px;font-size: 24px">${
                            item.value
                          }%</p> <div>${calcPercentWithPrevMonth(
                            item.data
                          )}</div></div>`
                        : `<div>
                          <p>${item.name} (${item.data.pigCount} con)</p>
                          <div>
                            <p style="font-size: 14px; margin-bottom:5px">Số lượng trại</p>
                           <div style="display:flex; align-items:center">
                           ${
                             item.name === "Trại Thịt"
                               ? '<div style="width:18px; height:18px; border-radius: 4px; margin-right: 5px; background-color: #F65C00;"></div>'
                               : '<div style="width:18px; height:18px; border-radius: 4px; margin-right: 5px; background-color:#0E42D2"></div>'
                           }
                           <p style="font-size: 20px; margin:0px">${item.value}</p>
                           </div>
                          </div>
                        </div>`
                    )
                    .join("")}
                </div>`;
      },
    },

    geometryOptions: [
      {
        geometry: "column",
        isGroup: true,
        seriesField: "name",
        color: ({ name }) => {
          if (name === "Trại Nái") return "#0095FF";
          return "#F7BA1E";
        },
        label: {
          position: "middle",
          style: {
            fill: "#FFFFFF",
            opacity: 0.8,
            fontSize: 12,
          },
        },
      },
      {
        geometry: "line",
        seriesField: "name",
        lineStyle: ({ name }) => {
          if (name === "Trại Nái") {
            return {
              opacity: 1,
              stroke: "#0095FF",
            };
          }

          if (name === "Trại Thịt") {
            return {
              opacity: 1,
              stroke: "#F7BA1E",
            };
          }
        },
      },
    ],
  };
  return (
    <Box className={classes.container}>
      <h1>Kết quả kiểm tra của trại trong năm</h1>
      <DualAxes {...config} />
    </Box>
  );
};

export default ChartStatisticFarm;
